"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
const React = require("react");
const react_native_1 = require("react-native");
class Loading extends React.Component {
    constructor() {
        super(...arguments);
        this.getWidthAndHeight = () => {
            const dim = react_native_1.Platform.OS === 'web' ? 'window' : 'screen';
            const { width, height } = this.props;
            return {
                width: width ? width : react_native_1.Dimensions.get(dim).width,
                height: height ? height : react_native_1.Dimensions.get(dim).height
            };
        };
    }
    render() {
        const { width, height } = this.getWidthAndHeight();
        return (React.createElement(react_native_1.View, { style: [styles.backgroundView, { width, height }] },
            React.createElement(react_native_1.ActivityIndicator, { size: "large", color: "#aaa", style: [styles.indicator, { width, height }] })));
    }
}
exports.Loading = Loading;
const styles = react_native_1.StyleSheet.create({
    backgroundView: {
        zIndex: 9998,
        position: 'absolute',
        opacity: 0.6,
        backgroundColor: '#ccc',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0 // IE fix
    },
    indicator: {
        zIndex: 9999,
        position: 'absolute',
        justifyContent: 'space-around',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0 // IE fix
    }
});
